import type {
  GetTranslationResponse,
  TranslationGetRequestBody,
} from '@/server/api/rest/translation/translation-types';
import { fetchTranslation } from '@/shared/api/translation/fetch-translation.api';
import { useQuery } from '@tanstack/react-query';

type UseDatabaseTranslationProps = TranslationGetRequestBody & {
  enabled?: boolean;
};

export const useDatabaseTranslation = ({
  model,
  fields,
  foreignKey,
  locale,
  enabled,
}: UseDatabaseTranslationProps) => {
  return useQuery<GetTranslationResponse>({
    queryKey: ['translation', 'model', 'fields', 'foreignKey'],
    queryFn: () =>
      fetchTranslation({
        model,
        fields,
        foreignKey,
        locale,
      }),
    enabled,
  });
};
